import React from 'react';
import { Card } from '../../components/ui/card';
import { centsToDollarString } from '../constants';

export const PIE_COLORS = {
  materials: '#38BDF8',
  employees: '#F59E0B',
  subs: '#A78BFA',
  profit: '#22C55E',
};

// SVG donut fed by the SAME authoritative cents values as the summary rows.
export const FinancialPie = ({ materialsNet, employees, subs, profit }) => {
  const segs = [
    { key: 'materials', label: 'Materials / Misc', value: Math.max(materialsNet || 0, 0), color: PIE_COLORS.materials },
    { key: 'employees', label: 'Employee Costs', value: Math.max(employees || 0, 0), color: PIE_COLORS.employees },
    { key: 'subs', label: 'Subcontractor Costs', value: Math.max(subs || 0, 0), color: PIE_COLORS.subs },
    { key: 'profit', label: 'Potential Gross Profit', value: profit != null && profit > 0 ? profit : 0, color: PIE_COLORS.profit },
  ];
  const total = segs.reduce((a, s) => a + s.value, 0);

  return (
    <Card className="bg-[#111111] border-gray-800 p-5" data-testid="financial-pie-card">
      <h4 className="text-sm font-semibold text-white mb-4">Cost & Profit Breakdown</h4>
      {total <= 0 ? (
        <p className="text-xs text-gray-500 py-6 text-center" data-testid="financial-pie-empty">
          No cost or profit data recorded yet.
        </p>
      ) : (
        <div className="flex flex-col sm:flex-row items-center gap-6">
          <svg viewBox="0 0 42 42" className="w-40 h-40 shrink-0" data-testid="financial-pie-svg">
            {(() => {
              let offset = 25;
              return segs.filter((s) => s.value > 0).map((s) => {
                const pct = (s.value / total) * 100;
                const el = (
                  <circle
                    key={s.key}
                    cx="21" cy="21" r="15.915"
                    fill="transparent"
                    stroke={s.color}
                    strokeWidth="7"
                    strokeDasharray={`${pct} ${100 - pct}`}
                    strokeDashoffset={offset}
                  />
                );
                offset -= pct;
                return el;
              });
            })()}
          </svg>
          <div className="space-y-2 w-full">
            {segs.map((s) => (
              <div key={s.key} className="flex items-center justify-between gap-3 text-xs" data-testid={`pie-legend-${s.key}`}>
                <span className="flex items-center gap-2 text-gray-300">
                  <span className="h-2.5 w-2.5 rounded-sm shrink-0" style={{ background: s.color }} />
                  {s.label}
                </span>
                <span className="text-white font-medium">
                  {s.key === 'profit' && profit == null
                    ? 'Needs budget'
                    : `${centsToDollarString(s.value)}${total > 0 ? ` · ${Math.round((s.value / total) * 100)}%` : ''}`}
                </span>
              </div>
            ))}
            {profit != null && profit < 0 && (
              <p className="text-[11px] text-red-400">Costs exceed the budget by {centsToDollarString(-profit)} — no profit slice shown.</p>
            )}
          </div>
        </div>
      )}
    </Card>
  );
};
